/* index.tsx generated by @compiled/babel-plugin v3.0.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIgd8bj%7Bfont%3Avar(--ds-font-heading-xxsmall%2Cnormal%20653%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
import { defineMessages, useIntl } from 'react-intl';
import { LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK } from '../../../common/constants';
import { GenericErrorSVG } from '../../../common/generic-error-svg';
import { EmptyState } from '../../../common/ui/empty-state';
import { MinHeightContainer } from '../../../common/ui/min-height-container';
const errorBoundaryFallbackStyles = null;
const messages = defineMessages({
  heading: {
    defaultMessage: 'Something went wrong!',
    description: 'Heading displayed when an unhandled error occurs.',
    id: 'fabric.linkPicker.unhandledError.heading'
  },
  description: {
    defaultMessage: 'Try reloading the page.',
    description: 'Body message shown underneath the heading when an unhandled error occurs.',
    id: 'fabric.linkPicker.unhandledError.description'
  }
});
export const ErrorBoundaryFallback = (): JSX.Element => {
  const intl = useIntl();
  const header = intl.formatMessage(messages.heading);
  const description = intl.formatMessage(messages.description);
  return <MinHeightContainer minHeight={LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK} data-testid="link-picker-root-error-boundary-ui" className={ax(["_2sNsIgd8bj"])}>
			<EmptyState header={header} renderImage={() => <GenericErrorSVG />} description={description} />
		</MinHeightContainer>;
};